export { default } from "./details-field";
